import { useState } from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { ApplePayMark } from "./PayMarks";

// «Добавить в Apple Wallet» на экране карты.
//
// Картинка — официальный вектор Apple, не наша перерисовка. Их правила на этот
// счёт недвусмысленны: «Be sure to use the badges provided by Apple. Do not
// create your own versions. Use the SVG artwork provided by Apple for badges on
// your web pages». Присланный скриншот (111x35) для этого не годился: на 3x
// экране под него нужно ~420 px по ширине, растянутый растр мылит.
//
// Файл один на обе темы, и это не экономия. Apple делит бейджи так: сплошной —
// на белый и светлый фон, контурный — на очень тёмный. У этого есть внешняя
// рамка #B1B3B6, то есть он и есть контурный вариант, а тёмная тема у нас
// основная. На светлом фоне рамка читается как тонкий серый кант и не мешает.
//
// Выпадение в заглушку оставлено на случай, если файл пропадёт при раскатке:
// она не притворяется бейджем Apple, а честно говорит текстом.
const BADGE = "/icons/wallet/add-to-apple-wallet.svg";

// viewBox бейджа — 110.095 x 34.016. Соотношение отдаём разметкой заранее,
// чтобы блок не дёрнулся, когда SVG догрузится.
const BADGE_W = 142;
const BADGE_H = 44;

const WalletBadge = ({ onAdd, onDismiss }) => {
  const { t } = useTranslation();
  const [noArtwork, setNoArtwork] = useState(false);

  return (
    // Отступ вокруг бейджа — требование Apple: не меньше 0.1 от его высоты.
    // При высоте 44 это 4.4, берём 6. Крестик стоит ЗА этой границей, в
    // свободном поле справа, а не поверх бейджа.
    <div className="relative px-9 py-1.5">
      <button
        type="button"
        onClick={onAdd}
        className={cn(
          "lp-press mx-auto flex h-11 items-center justify-center gap-2 rounded-[10px]",
          noArtwork &&
            "w-full max-w-[280px] border border-white/15 bg-black/70 px-4 text-[12px] font-semibold text-white backdrop-blur-[14px]"
        )}
        data-testid="wallet-badge"
      >
        {noArtwork ? (
          <>
            <ApplePayMark className="h-4 w-auto" />
            <span className="opacity-40">|</span>
            {t("cards.wallet_add_apple")}
          </>
        ) : (
          <img
            src={BADGE}
            alt={t("cards.wallet_add_apple")}
            width={BADGE_W}
            height={BADGE_H}
            className="h-11 w-auto"
            onError={() => setNoArtwork(true)}
            decoding="async"
            draggable="false"
          />
        )}
      </button>

      {/* Закрыть навсегда. Область нажатия 36 пунктов при значке в 14: сам
          крестик маленький, чтобы не спорить с бейджем, но промахнуться по
          нему нельзя. */}
      <button
        type="button"
        onClick={onDismiss}
        aria-label={t("cards.wallet_badge_hide")}
        className="lp-press absolute right-0 top-0 flex h-9 w-9 items-center justify-center rounded-full text-muted-foreground"
        data-testid="wallet-badge-dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default WalletBadge;
